module.exports = __webpack_public_path__ + "assets/img/dayu_shop_suspend.5ed7b1fc.png";